<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row dense>
          <v-col class="pa-0 ma-0">
            <div v-if="members.length <= 0" class="text-center"><br /><br /><span class="red--text font-weight-bold ">No OJTs to Display</span></div>
            <template v-else v-for="spectrack in getSpecTracks()">
              <v-layout class="justify-center blue darken-4" :key="spectrack + 'layout'">
                <div class="blue darken-4"><label><span class="font-weight-bold white--text">{{toProperCase(spectrack)}}</span>&nbsp;</label></div>
              </v-layout>
              <v-list :key="spectrack + 'list'">
                <v-list-item-group active-class="blue--text">
                  <template v-for="(member, index) in getMembers(spectrack)">
                    <v-list-item :key="index + 'item'">
                      <!-- eslint-disable-next-line -->
                      <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                          <v-list-item-title class="subtitle-1 font-weight-bold blue--text text--darken-4" v-text="getNameString(member) + ' (' + toProperCase(member.level) +')'" />
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-list-item-action-text >
                            <v-btn depressed outlined text icon medium color="blue darken-4" :to="`/memberinfo/type/capid/${member.capid}`">
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                          </v-list-item-action-text>
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                    <v-divider :key="index + 'divider'" />
                  </template>
                </v-list-item-group>
              </v-list>
            </template>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Begin - Loading Data Modal -->
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading Data...
          <v-progress-linear
            indeterminate
            rounded
            color="white"
            class="mb-0"
            height="20px"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->

  </div>    
</template>

<script>
export default {
  name: 'SpecialtyTracksByUnitMembers',
  props: {
    groupid: {
      type: String,
      default: null
    },
    orgid: {
      type: String,
      default: null
    }
  },
  components: {
  },
  data() {
    return {
      isLoading: false,
      members: [],
    }
  },
  mounted() {
    this.getSpecTracksByUnit();
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);
  },
  methods: {
    getNameString(member) {
      return [member.grade, member.firstname, member.middlename, member.lastname, member.suffix].filter(Boolean).join(" ");
    },
    getMembers(track) {
      return this.members.filter(member => member.track == track);
    },
    getSpecTracks() {
      return [... new Set(this.members.map(entry => entry.track))];
    },
    getSpecTracksByUnit() {

      this.isLoading = true;
      this.$https.post(this.$vars.BaseUrl + this.$vars.GetSpecTracksByUnitRoute, {wing: this.selWing, id: this.orgid}, this.$vars.config)
        .then(response => {
          //console.log(response);
          this.httpResponse = response;
          this.members = response.data;
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          this.isLoading = false;
        });


      this.isLoading = false;
    },
    toProperCase(str) {
      str = str.toLowerCase().split(' ');
      for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
      }
      return str.join(' ');
    }
  },
}
</script>
